import React, { useState } from 'react';

const Modal = ({ show, onClose, message }) => {
  if (!show) return null;

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.container}>
        <p>{message}</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    background: 'white',
    padding: '20px',
    borderRadius: '5px',
    textAlign: 'center',
  },
};

const MasterImage = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false); // State for modal visibility

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };
  const userID = localStorage.getItem('userID');

  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage('Please select a file first!');
      setShowModal(true); // Show modal
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/member/PostImageUpload?ID=${userID}`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setMessage('File uploaded and converted to PNG successfully.');
        setShowModal(true); // Show modal
      } else {
        const errorData = await response.json();
        setMessage(`Error: ${errorData.Message || 'Upload failed.'}`);
        setShowModal(true); // Show modal
      }
    } catch (error) {
      setMessage(`Error: ${error.message}`);
      setShowModal(true); // Show modal
    }
  };

  const closeModal = () => {
    setShowModal(false); // Hide modal
    setMessage(''); // Clear message
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <h2>Upload and Preview Image</h2>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {previewUrl && (
        <div style={{ marginTop: '20px' }}>
          <h3>Image Preview:</h3>
          <img
            src={previewUrl}
            alt="Preview"
            style={{ maxWidth: '300px', height: 'auto', border: '1px solid #ddd', padding: '10px' }}
          />
        </div>
      )}
      <button onClick={handleUpload} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }}>
        Upload Image
      </button>
      <Modal message={message} onClose={closeModal} /> {/* Modal for messages */}
    </div>
  );
};

export default MasterImage;
